import { High } from '@/models/security-method-enums-generated'
import type { MethodForm } from '@/types/module'

export const validCategories = (method: MethodForm) => {
	if (method.type === High && !method.confidentiality && !method.integrity && !method.availability) {
		return false
	}

	return true
}
